import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAccountScope } from "@/context/AccountScopeContext";
import { ALL_ACCOUNTS } from "@/lib/accountScope";
import { accountTypeMeta } from "@/lib/accounts";
import { Stack } from "@phosphor-icons/react";

/**
 * The global account filter. With a single account there is nothing to
 * choose between, so it stays out of the way until a second one exists.
 */
export default function AccountScopeSelect() {
  const { accounts, scope, setScope } = useAccountScope();
  if (accounts.length < 2) return null;

  return (
    <Select value={scope} onValueChange={setScope}>
      <SelectTrigger
        aria-label="Account"
        data-testid="account-scope-select"
        className="h-9 w-[150px] min-w-0 shrink bg-card border-border text-sm sm:w-[200px]"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-card border-border">
        <SelectItem value={ALL_ACCOUNTS} data-testid="account-scope-all">
          <span className="flex items-center gap-2">
            <Stack size={15} className="shrink-0 text-muted-foreground" /> All accounts
          </span>
        </SelectItem>
        {accounts.map((account) => {
          const Icon = accountTypeMeta(account.type).icon;
          return (
            <SelectItem key={account.id} value={account.id} data-testid={`account-scope-${account.id}`}>
              <span className="flex min-w-0 items-center gap-2">
                <Icon size={15} className="shrink-0 text-muted-foreground" />
                <span className="truncate">{account.name}</span>
              </span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
